import React from 'react'
import s from './styles/SortableHeaderCell.module.scss'
import { useSortableHeaderCell } from './hooks/useSortableHeaderCell'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'

const CheckIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7ZM6.60053 9.996L10.6307 4.95787L9.90267 4.37547L6.46613 8.66973L4.032 6.6416L3.43467 7.3584L6.60053 9.996Z"
			fill="currentColor"
		/>
	</svg>
)

export const SortableHeaderCell = ({
	label,
	isActive = false,
	dir = 'asc',
	options = [],
	onSelect,
	className = '',
	labelClassName = '',
}) => {
	const { isOpen, triggerRef, menuRef, toggle, close, handleSelect } =
		useSortableHeaderCell({ onSelect })

	return (
		<div className={`${s.wrap} ${isOpen ? s.open : ''} ${className}`.trim()}>
			<button
				ref={triggerRef}
				type="button"
				className={`${s.btn} ${isActive ? s.active : ''}`.trim()}
				onClick={toggle}
			>
				<span className={`${s.label} ${labelClassName}`.trim()}>{label}</span>
				<span
					className={`${s.arrow} ${isActive ? s.arrowActive : ''} ${
						isActive && dir === 'desc' ? s.arrowDesc : ''
					}`.trim()}
					aria-hidden="true"
				>
					<ArrowIcon />
				</span>
			</button>

			{isOpen && (
				<div ref={menuRef} className={s.menu} role="menu">
					{options.map(opt => {
						const selected = isActive && opt?.dir === dir

						return (
							<button
								key={String(opt.id)}
								type="button"
								className={`${s.menu__item} ${selected ? s.active : ''}`.trim()}
								onClick={() => {
									handleSelect(opt)
									close()
								}}
								role="menuitem"
							>
								<span className={s.menu__text}>{opt.label}</span>
								{selected && (
									<span className={s.menu__check} aria-hidden="true">
										<CheckIcon />
									</span>
								)}
							</button>
						)
					})}
				</div>
			)}
		</div>
	)
}
